import { BaseHighchart } from '@/common/dashboard/charts/BaseHighchart';
import { Mode } from '@/common/entityFramework/enumerations/Mode';
import { useNavState } from '@/common/navState/NavStateContext';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { useEffect, useState } from 'react';

export const ChbkLineVolumeAmtPaidChart = ({ selectedPeriod, selectedDistCusts }) => {

    const rsrc = useRsrc();
    const { navigateTo } = useNavState();

    const [data, setData] = useState();

    useEffect(() => {
        if (!selectedPeriod?.id) {
            return null;
        }

        const distCustIds = selectedDistCusts.map(distCust => distCust.id);
        const reqParam = {
            periodId: selectedPeriod?.id,
            distCustIds
        }

        rsrc.data('sc', 'CHBK_LINE_VOLUME_AMT_PAID_DATA_PLUGIN', reqParam).then(data => {
            setData(data);
        })

    }, [selectedPeriod, selectedDistCusts]);

    if (!data) return null;

    const categories = data.map(d => d.month);

    const navigateToIndirSaleList = (category) => {
        rsrc.rows('sc', 'PERIOD', { expr: ExprUtils.whereParams('code', category) }).then(periods => {
            if (!periods?.length) return;
            let expr = ExprUtils.whereParams('rcvdPeriodId', periods[0].id);

            const distCustIds = selectedDistCusts?.map(dc => dc.id) ?? [];
            if (distCustIds.length > 0) {
                expr = ExprUtils.and(expr, ExprUtils.whereParams('distCustId', distCustIds));
            }

            navigateTo('sc/indir-sale', { mode: Mode.LIST, expr });
        });
    };

    const options = {
        chart: {
            spacing: [8, 8, 8, 8],
        },

        title: { text: null },
        credits: { enabled: false },
        tooltip: { shared: true },

        plotOptions: {
            series: {
                cursor: 'pointer',
                point: {
                    events: {
                        click() {
                            navigateToIndirSaleList(this.category);
                        },
                    },
                },
            },
        },

        xAxis: {
            categories,
            title: { text: 'Month Received' },
        },

        yAxis: [
            {
                title: { text: 'Paid Amount' },
                labels: {
                    formatter() {
                        return `$${this.value.toLocaleString()}`;
                    },
                },
                min: 0,
            },
            {
                title: { text: 'Lines Processed' },
                labels: {
                    formatter() {
                        return this.value.toLocaleString();
                    },
                },
                opposite: true,
                min: 0,
            },
        ],

        series: [
            {
                name: 'Paid Amount',
                type: 'column',
                yAxis: 0,
                data: data.map(d => d.paid),
                tooltip: {
                    valuePrefix: '$',
                    valueDecimals: 0,
                },
            },
            {
                name: 'Lines Processed',
                type: 'spline',
                yAxis: 1,
                data: data.map(d => d.lines),
            },
        ],
    };

    return <BaseHighchart options={options} />;
}
